import { render, staticRenderFns } from "./store-backstaff.vue?vue&type=template&id=185af1a0&scoped=true"
import script from "./store-backstaff.vue?vue&type=script&lang=js"
export * from "./store-backstaff.vue?vue&type=script&lang=js"
import style0 from "./store-backstaff.vue?vue&type=style&index=0&id=185af1a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185af1a0",
  null
  
)

export default component.exports